// src/firebaseConfig.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent, setUserId, setUserProperties } from 'firebase/analytics';

// Ensure you're using environment variables correctly for Vite
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Prevent multiple initializations
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

// Analytics Utility Functions
export const trackPageView = (pageName) => {
    try {
        logEvent(analytics, 'page_view', {
            page_title: pageName,
            page_path: window.location.pathname
        });
    } catch (error) {
        console.error('Analytics tracking error:', error);
    }
};

export const trackUserSignUp = (method) => {
    try {
        logEvent(analytics, 'sign_up', { method });
    } catch (error) {
        console.error('Sign up tracking error:', error);
    }
};

export const trackUserLogin = (method) => {
    try {
        logEvent(analytics, 'login', { method });
    } catch (error) {
        console.error('Login tracking error:', error);
    }
};

export const trackDreamCreation = (artStyle, hasImage) => {
    try {
        logEvent(analytics, 'create_dream', {
            art_style: artStyle,
            has_image: hasImage
        });
    } catch (error) {
        console.error('Dream creation tracking error:', error);
    }
};

export const trackInterpretation = (interpretationType) => {
    try {
        logEvent(analytics, 'dream_interpretation', {
            interpretation_type: interpretationType
        });
    } catch (error) {
        console.error('Interpretation tracking error:', error);
    }
};

export const setAnalyticsUserId = (userId) => {
    try {
        setUserId(analytics, userId);
    } catch (error) {
        console.error('Set user ID error:', error);
    }
};

export const setAnalyticsUserProperties = (properties) => {
    try {
        setUserProperties(analytics, properties);
    } catch (error) {
        console.error('Set user properties error:', error);
    }
};

export { app, auth, db, storage, analytics };